// extracted by mini-css-extract-plugin
module.exports = {"root":"car_summary_details__root__bL8hb text__text_align_center__2cSPH"};